import { useId } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { createDomSafeId } from "../helpers/onboardingAgentHelpers";
import { ONBOARDING_AGENT_AI_GRADIENT_COLORS } from "../onboardingAgentAiGradientTokens";
import { ONBOARDING_AGENT_LOADING_TEXT } from "../texts";

import {
    AnimatedLargeStar,
    AnimatedSmallStar,
    LoadingRow,
    SparklesFrame,
    SparklesIconShape,
    SparklesSvg,
} from "./styles";

export const OnboardingAgentLoadingIndicator = () => {
    const { translate } = useTranslate();
    const paintId = createDomSafeId("oa-loading-sparkles", useId());

    return (
        <LoadingRow data-automation="onboarding-agent-loading-indicator">
            <SparklesFrame aria-hidden>
                <SparklesIconShape>
                    <SparklesSvg
                        viewBox="0 0 22 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        preserveAspectRatio="xMidYMid meet"
                        focusable="false"
                    >
                        <defs>
                            <linearGradient
                                id={paintId}
                                x1="0"
                                y1="9.5"
                                x2="21.9995"
                                y2="9.60877"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stopColor={ONBOARDING_AGENT_AI_GRADIENT_COLORS.defaultStart} />
                                <stop
                                    offset={1}
                                    stopColor={ONBOARDING_AGENT_AI_GRADIENT_COLORS.defaultEnd}
                                />
                            </linearGradient>
                        </defs>
                        <AnimatedSmallStar>
                            <path
                                d="M18 8L19.25 5.25L22 4L19.25 2.75L18 0L16.75 2.75L14 4L16.75 5.25L18 8Z"
                                fill={`url(#${paintId})`}
                            />
                        </AnimatedSmallStar>
                        <AnimatedLargeStar>
                            <path
                                d="M10.5 8.5L8 3L5.5 8.5L0 11L5.5 13.5L8 19L10.5 13.5L16 11L10.5 8.5ZM8.99 11.99L8 14.17L7.01 11.99L4.83 11L7.01 10.01L8 7.83L8.99 10.01L11.17 11L8.99 11.99Z"
                                fill={`url(#${paintId})`}
                            />
                        </AnimatedLargeStar>
                    </SparklesSvg>
                </SparklesIconShape>
            </SparklesFrame>
            <Text
                fontVariant="input2"
                color={colorsPalettes.carbon[500]}
            >
                {translate(ONBOARDING_AGENT_LOADING_TEXT)}
            </Text>
        </LoadingRow>
    );
};
